import { t } from "@lingui/macro";
import { Box, Container } from "@mui/material";
import useNavUpOnDeviceDisconnect from "../useNavUpOnDeviceDisconnect";
import UpdateMapsEmbed from "./UpdateMapsEmbed";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";

const UpdateMaps = ({ appToken = "" }: { appToken: string }) => {
  useNavUpOnDeviceDisconnect(appToken);

  return (
    <>
      <GlobalHeader title={t`Update maps`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box width="100%" height="100%" display="flex" flexDirection="column" p={2} gap={4}>
          <UpdateMapsEmbed appToken={appToken} />
        </Box>
      </Container>
    </>
  );
};

export default UpdateMaps;
